import script from "./PlanRevisions.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanRevisions.vue?vue&type=script&setup=true&lang=js"

import "./PlanRevisions.vue?vue&type=style&index=0&id=20091791&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20091791"]])

export default __exports__